
import themes from "@/mixins/themes"
import Button from "@/components/base/Button"
import DatePicker from "@/components/base/input/Datepicker"

export default {
    name: "JobTraineeshipDatePicker",
    components: {
        Button,
        DatePicker,
    },
    emits: ["interested"],
    mixins: [themes],
    props: {
        /** Hides chat buttons */
        hideChat: {
            type: Boolean,
            default: false,
        },
        /** Hides header */
        hideHeader: {
            type: Boolean,
            default: false,
        },
        /** Theme's background type */
        themeBackground: {
            type: String,
            default: "backgroundSecondary",
        },
    },
    data: () => ({
        dates: [],
    }),
    computed: {
        computedDates: {
            get() {
                return this.dates
            },
            set(arr) {
                if (this.dates.includes(arr[1])) return
                if (arr.length === 0) this.dates = []
                else if (arr.length === 1) this.dates = arr
                else this.dates = this.sortDates(arr)
            },
        },
        startDate() {
            return new Date().toISOString().substring(0, 10)
        },
        endDate() {
            let date = ((d) => d.setFullYear(d.getFullYear() + 1))(new Date())
            return new Date(date).toISOString().substring(0, 10)
        },
        controlsColor() {
            // grey-6 : grey-2
            return this.oaTheme[this.themeBackground].isTextDark
                ? "#404040"
                : "#e6e6e6"
        },
        datepickerTheme() {
            const buttonPrimary = this.oaTheme.buttonPrimary.color
            return {
                text: this.oaTheme.backgroundPrimary.text.color,
                background:
                    typeof buttonPrimary === "string"
                        ? buttonPrimary
                        : buttonPrimary[1],
            }
        },
    },
    methods: {
        onInterested(type) {
            this.$oabalytics.trackEvent("interested_open")
            this.$survey?.startTimer()
            if (type === "flexible") this.$emit("interested")
            else this.$emit("interested", this.dates)
        },
    },
}
